"use client";
import { useRouter } from "@/i18n/routing";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";
import { useTheme } from "@emotion/react";
import { Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../Button";
import ModalComponent from "../Modal";

const NameMismatchModal = () => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const router = useRouter();
  const path = usePathname();
  const { open, message, type, error } = useSelector((state) => state?.modal);

  const handleButtonClick = () => {
    if (path && path !== "/en") {
      dispatch(setModalAttributes({ isRouting: true, targetRoute: "/" }));
      router.push("/");
    }
    dispatch(setModalAttributes({ open: false, message: "", type: "" }));
  };
  return (
    <ModalComponent
      maxWidth={isBelowMd ? "xs" : "md"}
      open={open}
      closeButtonRequired={false}
    >
      <Grid
        container
        spacing={3}
        padding={2}
        pb={0}
        // flexDirection={{ md: "row", xs: "column" }}
        alignItems="center"
        justifyContent={"space-between"}
        // gap={1}
      >
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            backgroundColor: { md: "#E9FFE6", xs: "none" },
            height: { md: "436px" },
            width: { md: "463px" },
          }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image
            src={IMAGES.nameMismatchFound}
            height={isBelowMd ? "120" : "191px"}
            width={isBelowMd ? "135" : "216px"}
            alt="Name Mismatch Found"
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={{ md: 700, xs: 500 }}
            fontSize={{ md: "24px", xs: "16px" }}
            color={WEB_COLORS.darkTeal}
            mb={1}
          >
            Name Mismatch Found
          </Typography>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={400}
            fontSize={{ md: "14px", xs: "12px" }}
            color={WEB_COLORS.textFadeColor}
            mb={2}
          >
            {message}
          </Typography>

          {error && <Typography
            textAlign={"center"}
            fontWeight={400}
            fontSize={{ md: "12px", xs: "10px" }}
            color={WEB_COLORS.errorColor}
            mb={2}
          >
            {error}
          </Typography>}

          <Stack width={"100%"} flexGrow={1}>
            <ButtonComponent onClick={handleButtonClick}>
              {path && path !== "/en" ? "Go to Homepage" : "Notify Me"}
            </ButtonComponent>
          </Stack>
        </Grid>
      </Grid>
    </ModalComponent>
  );
};

export default NameMismatchModal;
